import React, { useState, useEffect, useRef } from "react";
import { FiUser, FiMail, FiMessageSquare, FiX } from "react-icons/fi";
import { CiPhone } from "react-icons/ci";
import toast from "react-hot-toast";
import { FaPaperPlane } from "react-icons/fa";
import ReCAPTCHA from "react-google-recaptcha";

// const ContactFormPopup = () => {
const ContactFormPopup = ({ isGoogleAds = false }) => {
  const [showPopup, setShowPopup] = useState(false);
  const [showButton, setShowButton] = useState(false);
  const [isClosing, setIsClosing] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    message: "",
    subject: "Defence Housing Society web",
  });
  const [loading, setLoading] = useState(false);
  const popupRef = useRef(null);
  const recaptchaRef = useRef();
  const [captchaValue, setCaptchaValue] = useState(null);

  const [agreed, setAgreed] = useState(false);
  const [agreeError, setAgreeError] = useState("");

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  // Auto-show popup on initial load
  // useEffect(() => {
  //   const timer = setTimeout(() => {
  //     setShowPopup(true);
  //   }, 3000);

  //   return () => {
  //     clearTimeout(timer);
  //   };
  // }, []);

  useEffect(() => {
    const dismissed = localStorage.getItem("contactPopupDismissed");

    // If user already closed popup before
    if (dismissed === "true") {
      setShowPopup(false);
      setShowButton(true);
      return;
    }

    const timer = setTimeout(() => {
      setShowPopup(true);
    }, 3000);

    return () => {
      clearTimeout(timer);
    };
  }, []);

  const handleClose = () => {
    setIsClosing(true);

    // Save dismissal across pages
    localStorage.setItem("contactPopupDismissed", "true");

    setTimeout(() => {
      setShowPopup(false);
      setIsClosing(false);
      setShowButton(true); // Show button after closing
    }, 500);
  };

  const handleButtonClick = () => {
    setShowPopup(true);
    setShowButton(false);
  };

  const validateAgreement = () => {
    if (!agreed) {
      setAgreeError(
        "You must agree to the Terms and Privacy Policy to continue.",
      );
      toast.error("Please accept Terms and Privacy Policy.");
      return false;
    }
    setAgreeError("");
    return true;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!captchaValue) {
      toast.error("Please verify that you are not a robot!");
      return;
    }

    if (!validateAgreement()) return;

    setLoading(true);

    try {
      const res = await fetch(
        "https://adminpanel.defencehousingsociety.com/defenceWebsiteRoutes/contactus",
        // "http://localhost:4000/defenceWebsiteRoutes/contactus",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            ...formData,
            captchaValue,
            source: isGoogleAds ? "google_ads" : "website", // Add source to payload
            declaration: agreed,
          }),
        },
      );

      if (res.ok) {
        toast.success("Message sent successfully!");
        setFormData({
          name: "",
          email: "",
          phone: "",
          message: "",
          subject: isGoogleAds
            ? "Google Ads Lead"
            : "Defence Housing Society web", // Modify subject based on source
        });
        setCaptchaValue(null);
        setAgreed(false);
        handleClose();
      } else {
        toast.error("Failed to send message.");
      }
      recaptchaRef.current.reset();
      setCaptchaValue(null);
    } catch (error) {
      toast.error("Something went wrong!");
    } finally {
      setLoading(false);
    }
  };

  return (
    // <div className="fixed bottom-4 right-4 z-50">
    <div className="fixed bottom-1 short:top-[70px] right-4 z-[9999]">
      {/* Contact Button - Only shows after popup is closed */}
      {showButton && !showPopup && !isClosing && (
        <button
          onClick={handleButtonClick}
          className="bg-[#24447c] text-white px-6 py-3 rounded-full shadow-lg hover:bg-sky-700 transition-all duration-300 flex items-center justify-center"
          style={{
            boxShadow: "0 4px 15px rgba(59, 130, 246, 0.5)",
          }}
        >
          <FaPaperPlane className="mr-2" />
          Contact Us
        </button>
      )}

      {/* Contact Form Popup */}
      {showPopup && (
        <div
          ref={popupRef}
          className={`bg-white rounded-xl shadow-xl w-80 overflow-hidden transition-all duration-500 transform ${
            isClosing ? "animate-slideOut" : "animate-slideIn"
          }`}
          style={{
            boxShadow: "0 10px 25px rgba(0, 0, 0, 0.1)",
          }}
        >
          <div className="flex justify-between items-center p-2 bg-gradient-to-r from-[#24447c] to-blue-600">
            <h2 className="text-lg font-semibold text-white">Contact Us</h2>
            <button
              onClick={handleClose}
              className="text-white hover:text-gray-200 transition-colors duration-200"
            >
              <FiX size={20} />
            </button>
          </div>

          <div className="p-4">
            <form className="space-y-4" onSubmit={handleSubmit}>
              <div className="relative">
                {/* <label className="block text-sm text-gray-600 mb-1">Name</label> */}
                <div className="relative">
                  <FiUser className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" />
                  <input
                    type="text"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    className="w-full pl-10 pr-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200 hover:border-gray-400"
                    placeholder="Your Name"
                    required
                  />
                </div>
              </div>

              <div className="relative">
                {/* <label className="block text-sm text-gray-600 mb-1">
                  Email
                </label> */}
                <div className="relative">
                  <FiMail className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" />
                  <input
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    className="w-full pl-10 pr-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200 hover:border-gray-400"
                    placeholder="you@example.com"
                    required
                  />
                </div>
              </div>

              <div className="relative">
                {/* <label className="block text-sm text-gray-600 mb-1">
                  Mobile No
                </label> */}
                <div className="relative">
                  <CiPhone className="text-1xl absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-800" />
                  <input
                    type="number"
                    name="phone"
                    value={formData.phone}
                    onChange={handleChange}
                    className="w-full pl-10 pr-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200 hover:border-gray-400"
                    placeholder="Mobile No"
                    required
                  />
                </div>
              </div>

              <div className="relative">
                {/* <label className="block text-sm text-gray-600 mb-1">
                  Message
                </label> */}
                <div className="relative">
                  <FiMessageSquare className="absolute left-3 top-3 text-gray-400" />
                  <textarea
                    rows="1"
                    name="message"
                    value={formData.message}
                    onChange={handleChange}
                    className="w-full pl-10 pr-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200 hover:border-gray-400"
                    placeholder="Your message..."
                    required
                  ></textarea>
                </div>
              </div>
              <div className="scale-75 origin-left -mt-3 mb-1">
                <ReCAPTCHA
                  ref={recaptchaRef}
                  // sitekey="6LequKcrAAAAAKR_okRav96T4sMTa5FBs9s9JURL"
                  sitekey="6LfarqkrAAAAAFUBBVCodI4OdoTheC6uB1hdtITz"
                  onChange={(value) => setCaptchaValue(value)}
                />
              </div>

              <div className="form-group checkbox-group text-sm">
                <label className="inline-flex items-start gap-2">
                  <input
                    type="checkbox"
                    checked={agreed}
                    onChange={(e) => {
                      setAgreed(e.target.checked);
                      if (e.target.checked) setAgreeError("");
                    }}
                    className="mt-1"
                    aria-required="true"
                  />
                  <span className="ml-1 text-gray-700">
                    I agree to the{" "}
                    <a
                      href="/terms-conditions"
                      // target="_blank"
                      rel="noopener noreferrer"
                      className="text-blue-600 underline"
                    >
                      Terms and Conditions
                    </a>{" "}
                    and{" "}
                    <a
                      href="/privacy-policy"
                      // target="_blank"
                      rel="noopener noreferrer"
                      className="text-blue-600 underline"
                    >
                      Privacy Policy
                    </a>
                    .
                  </span>
                </label>
                {agreeError && (
                  <p className="text-xs text-red-600 mt-1">{agreeError}</p>
                )}
              </div>

              <button
                type="submit"
                disabled={loading}
                className={`w-full bg-[#24447c] text-white py-2 rounded-md hover:bg-sky-700 transition-colors duration-200 flex items-center justify-center ${
                  loading ? "opacity-75 cursor-not-allowed" : ""
                }`}
              >
                {loading ? (
                  <>
                    <svg
                      className="animate-spin -ml-1 mr-3 h-5 w-5 text-white"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                    >
                      <circle
                        className="opacity-25"
                        cx="12"
                        cy="12"
                        r="10"
                        stroke="currentColor"
                        strokeWidth="4"
                      ></circle>
                      <path
                        className="opacity-75"
                        fill="currentColor"
                        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                      ></path>
                    </svg>
                    Sending...
                  </>
                ) : (
                  <span className="inline-flex items-center gap-2">
                    Submit <FaPaperPlane />
                  </span>
                )}
              </button>
            </form>
          </div>
        </div>
      )}

      <style jsx global>{`
        @keyframes slideIn {
          from {
            transform: translateX(100%);
            opacity: 0;
          }
          to {
            transform: translateX(0);
            opacity: 1;
          }
        }

        @keyframes slideOut {
          from {
            transform: translateX(0);
            opacity: 1;
          }
          to {
            transform: translateX(100%);
            opacity: 0;
          }
        }

        .animate-slideIn {
          animation: slideIn 0.5s ease-out forwards;
        }

        .animate-slideOut {
          animation: slideOut 0.5s ease-in forwards;
        }
      `}</style>
    </div>
  );
};

export default ContactFormPopup;
